'use client';

export {
    createProductInfoGroup,
    generate as generateProductInfoGroup,
    showCutList as productInfoGroupShowCutList,
    productInfoGroupTypeKey,
} from './define';

export { ProductInfoGroup } from './ProductInfoGroup';
